import { ReactHtmlParser } from "../ReactHtmlParser";

import { elementAttributes } from "../config";
import { getNamedAttribute } from "./getNamedAttribute";

/**
 * Helper that returns all allowed HTML attributes from the given element,
 * mapped into their related React props as specified in the elementAttributes.
 */
export function getPropsFromAttributes(
  elem: Element,
  parser: ReactHtmlParser
): { [key: string]: string | boolean } {
  // Grab the list of supported HTML attributes for the given element type
  const attrs = elementAttributes[elem.tagName.toLowerCase()];

  // Prepare object that'll contain the corresponding React props needed for
  // the rendering of the given attributes
  const props: { [key: string]: string | boolean } = {};

  // Loop over allowed attributes and convert them to jsx props
  Object.keys(attrs).forEach((attr) => {
    // Bail out, if the attribute is not allowed
    if (!parser.isAttrAllowed(attr)) {
      return;
    }

    const propName = attrs[attr];
    const propValue = getNamedAttribute(elem, attr);

    if (propValue !== undefined) {
      props[propName] = propValue;
    }
  });

  return props;
}
